import { CAMERA_CONTROLS_NODE_TYPES } from "../../engine/poly/NodeContext";
import { CoreObject } from "../geometry/Object";
import { CameraAttribute } from "./CoreCamera";
import { CoreType } from "../Type";
export class CoreCameraControlsController {
  static isCameraControlsNode(node) {
    return CAMERA_CONTROLS_NODE_TYPES.includes(node.type());
  }
  static controlsNode(options) {
    const { scene, camera } = options;
    let controlsNode;
    const foundNodePath = CoreObject.attribValue(camera, CameraAttribute.CONTROLS_PATH);
    if (foundNodePath && CoreType.isString(foundNodePath)) {
      const foundNode = scene.node(foundNodePath);
      if (foundNode && this.isCameraControlsNode(foundNode)) {
        controlsNode = foundNode;
      }
    }
    return controlsNode;
  }
}
